import { render } from "./HospitalLightfortheworld.vue?vue&type=template&id=3a56eae0&scoped=true"
import script from "./HospitalLightfortheworld.vue?vue&type=script&lang=js"
export * from "./HospitalLightfortheworld.vue?vue&type=script&lang=js"

import "./HospitalLightfortheworld.vue?vue&type=style&index=0&id=3a56eae0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a56eae0"]])

export default __exports__